export const getSupportedLanguages= (): string[] => (process.env.GATSBY_SITE_SUPPORTED_LANGUAGES ?? '').split(',')